module.exports = __webpack_public_path__ + "static/media/icon_simple_file_summary.42cc99e5.svg";